<template>
  <div>
    <!-- 关联订单二维码-->
    <el-dialog title="生成订单关联二维码" :visible="visible" :close-on-click-modal="false" center width="600px" @close="closeFn" custom-class="dialog-qrcode-wrap">
      <div style="display: flex;">
        <div class="dialog-content">
          <div slot ref="dialogContent">
            <div style="height: 24px;line-height: 24px; font-size: 18px; color: #303133;font-weight: bold;margin-bottom: 10px;">{{textareaVal}}</div>
            <div style="color: #ed272f">订单号：{{ orderDetail.order.orderNo }} </div>
            <div style="color: #ed272f">产品名称：{{ orderDetail.order.visaTitle }}</div>
            <div style="color: #ed272f" v-if="formattedDepartureTime">预计出行：{{ formattedDepartureTime }}</div>
            <div style="color: #ed272f" v-if="orderDetail.order.planVisaDate">预计出签：{{ orderDetail.order.planVisaDate.slice(0, 10) }}</div>

            <div style="margin: 30px; display: flex;  justify-content: center;">
              <el-image style="width: 200px; height: 200px" :src="qrcodeImgUrl" lazy></el-image>
            </div>

            <div style="color: #ed272f; display: flex;  justify-content: center;">扫一扫关联订单，随时查询和下载签证页</div>
          </div>
          <div style="display: flex; justify-content: center;margin: 20px 0;">
            <!-- <el-button type="primary" @click="copyDialogContent" :loading="qrcodeImgLoading">
              <i class="el-icon-copy-document"></i> 内容截图
            </el-button> -->
          </div>

          <div>操作备注</div>
          <el-input placeholder="请输入备注" v-model="textareaVal" clearable>
            <el-button type="primary" slot="append" @click="submitTextareaFn">保存</el-button>
          </el-input>

        </div>

        <div slot class="dialog-content" v-if=" orderDetail.order.orderSource == 1">
          <!-- <div style=" line-height: 24px; font-size: 18px; color: #303133;font-weight: bold;margin-bottom: 10px;">快速上传链接</div> -->
          <div style="height: 24px;line-height: 24px; font-size: 18px; color: #303133;font-weight: bold;">{{textareaVal}}</div>
          <div style="color: #ed272f">订单号：{{ orderDetail.order.orderNo }} </div>
          <div style="color: #ed272f">{{ orderDetail.order.visaTitle }}</div>
          <div style="color: #ed272f" v-if="formattedDepartureTime">预计出行：{{ formattedDepartureTime }}</div>
          <div style="color: #ed272f" v-if="orderDetail.order.planVisaDate">预计出签：{{ orderDetail.order.planVisaDate.slice(0, 10) }}</div>

          <div v-loading="copyUrlLoading" element-loading-spinner="el-icon-loading">

            <div class="qrcode-box">
              <el-image style="width: 140px; height: 140px" :src="copyUrlImg" lazy></el-image>
            </div>
            <div style="color: #ed272f;">扫一扫查看订单 <br /> 随时查询和下载签证页</div>

            <div style="display: flex; justify-content: center;margin-top: 60px;">
              <el-button v-if="copyUrl" type="text" @click="downLoadImage">
                <i class="el-icon-download"></i> 下载二维码
              </el-button>
            </div>
          </div>
          <div style="display: flex; justify-content: center;">
            <el-button v-if="copyUrl" type="text" v-clipboard:copy="copyUrl" v-clipboard:success="copySuccess">
              <i class="el-icon-copy-document"></i> 复制链接
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <canvas id="qrcode" width="120px" height="120px"></canvas>
  </div>
</template>

<script> 
import {
  wechatshareqrcode,
  getdefaultappinfo
} from "@/api/order.js";
import {
  orderremarks,
} from "@/api/orderCenter.js";
import UQRCode from 'uqrcodejs';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderDetail: {
      type: Object,
      default: {}
    }

  },
  computed: {
    formattedDepartureTime() {
      const departureTime = this.orderDetail?.order?.departureTime;

      if (!departureTime ||
        departureTime === 'invalid-date' ||
        departureTime.startsWith('0001-01-01')) {
        return '';
      }

      return departureTime.slice(0, 10);
    }
  },
  data() {
    return {
      qrcodeImgLoading: false,
      qrcodeImgUrl: '',
      textareaVal: '',
      copyUrl: '',
      copyUrlImg: '',
      copyUrlLoading: false,
      canvas: null,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.textareaVal = this.orderDetail.order.serviceMarks;
      }
    },
    // 精准监听：orderDetail.order.id 的变化
    'orderDetail.order.id': {
      handler(newId, oldId) {
        if (newId && newId != oldId) {
          this.qrcodeImgUrl = null;
          this.getQrcodeFn();

          this.copyUrlImg = null;
          if (this.orderDetail.order.id && this.orderDetail.order.orderSecertKey && this.orderDetail.order.orderSource == 1) {
            let url = 'https://visa-application-form.sport-syy.com/ApplicantsOrder';
            this.copyUrl = url + `?id=${this.orderDetail.order.id}&secretkey=${this.orderDetail.order.orderSecertKey}`;
            this.getCopyUrQrlcodeFn();
          }

        }
      },
      immediate: true // 组件挂载时立即检查（防止父组件初始就传了有id的orderDetail）
    }
  },
  methods: {
    closeFn() {
      this.$emit('close')
    },

    // 生成二维码
    getQrcodeFn() {
      getdefaultappinfo().then(res => {
        if (typeof res.data == 'string' && res.data.indexOf('暂未配置应用') > -1) {
          wechatshareqrcode({
            "appId": process.env.VUE_APP_DEFAULT_ID,
            "path": "/pages/order/pcorder_detail/index?id=" + this.orderDetail.order.id + '&orderSecertKey=' + this.orderDetail.order.orderSecertKey
          }).then(ares => {
            this.qrcodeImgUrl = ares.data;
            // 调用原生XHR方法
            this.loadImageWithXHR(this.qrcodeImgUrl);
          })
        } else if (res.code == 1) {
          wechatshareqrcode({
            "appId": res.data.outAppId,
            // "path": "/pages/index/order?connectorderid=" + this.orderDetail.order.id
            "path": "/pages/order/pcorder_detail/index?connectorderid=" + this.orderDetail.order.id
          }).then(ares => {
            this.qrcodeImgUrl = ares.data;
            // 调用原生XHR方法
            this.loadImageWithXHR(this.qrcodeImgUrl);
          })
        }
      })
    },

    getCopyUrQrlcodeFn() {
      let imgStc = this.copyUrl;
      if (!imgStc) return
      this.copyUrlLoading = true;
      // 获取uQRCode实例
      var qr = new UQRCode();
      // 设置二维码内容
      qr.data = imgStc;
      // 设置二维码大小，必须与canvas设置的宽高一致
      qr.size = 120;
      qr.margin = 5;
      // 调用制作二维码方法
      qr.make();
      // 获取canvas元素      
      this.canvas = document.getElementById("qrcode");
      // 获取canvas上下文
      var canvasContext = this.canvas.getContext("2d");
      // 设置uQRCode实例的canvas上下文
      qr.canvasContext = canvasContext;
      // 调用绘制方法将二维码图案绘制到canvas上
      qr.drawCanvas().then(() => {
        this.copyUrlImg = this.canvas.toDataURL();
        this.copyUrlLoading = false;
      });
    },
    downLoadImage() {
      var a = document.createElement("a");
      a.href = this.copyUrlImg;
      //   a.download = '六月初工具站-二维码生成';
      a.click();
    },
    loadImageWithXHR(imageUrl) {
      return

      // 构建代理URL
      const proxyUrl = `https://images.weserv.nl/?url=${encodeURIComponent(imageUrl)}`;
      this.qrcodeImgLoading = true;
      setTimeout(() => {
        this.qrcodeImgUrl = proxyUrl;

        setTimeout(() => {
          this.qrcodeImgLoading = false;
        }, 3000);

      }, 10000);
    },
    // 复制包含二维码的完整内容
    async copyDialogContent() {
      if (!this.qrcodeImgUrl) {
        this.$message.warning('二维码加载中，请稍后重试');
        return;
      }

      try {
        // 1. 使用html2canvas将内容转为canvas
        const canvas = await html2canvas(this.$refs.dialogContent, {
          useCORS: true, // 解决跨域图片问题
          scale: 2, // 提高清晰度
          logging: false // 关闭日志
        });

        // 2. 将canvas转为blob
        canvas.toBlob(blob => {
          // 3. 创建ClipboardItem对象
          const item = new ClipboardItem({ 'image/png': blob });

          // 4. 写入剪贴板
          navigator.clipboard.write([item]).then(() => {
            this.$message.success('内容已复制到剪贴板');
          }).catch(err => {
            console.error('复制失败:', err);
            this.$message.error('复制失败，请重试');
          });
        });
      } catch (err) {
        console.error('截图失败:', err);
        this.$message.error('生成截图失败，请重试');
      }

    },
    submitTextareaFn() {
      orderremarks({
        orderId: this.orderDetail.order.id,
        remarks: this.textareaVal,
      }).then((res) => {
        this.orderDetail.order.serviceMarks = this.textareaVal;
        this.$message.success("修改备注成功！");
      });
    },
    copySuccess() {
      this.$message({
        message: "复制成功！",
        type: "success",
      });
    }
  }

}
</script>

<style lang="scss" scoped>
#qrcode {
  position: fixed;
  bottom: -9999px;
  left: -9999px;
  z-inde: -9999;
  pointer-events: none;
  visibility: hidden;
  touch-action: none;
  user-select: none;
  outline: none;
}
::v-deep .dialog-qrcode-wrap {
  .el-dialog__body {
    padding: 0 !important;
  }
  .dialog-content {
    padding: 25px 25px 30px;
    .qrcode-box {
      width: 140px;
      height: 140px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #707070;
      display: flex;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: 10px;
      .tips {
        color: #d5d5d5;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 100%;
        font-size: 12px;
      }
    }
  }
}
</style>